export default __webpack_public_path__ + "static/media/key.00cf3ea1.png";